var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "display-inline": !_vm.isAlert,
        "small-alert alert-info": _vm.isOpen && _vm.isAlert,
        "small-alert alert-danger": !_vm.isOpen && _vm.isAlert,
      },
      attrs: { title: _vm.isOpen ? "open" : "closed" },
    },
    [
      _c("strong", [
        _c("span", [
          _c("i", {
            class: {
              "fa fa-exclamation-circle text-primary": _vm.isOpen,
              "fa fa-times-circle text-danger": !_vm.isOpen,
            },
            attrs: { "aria-hidden": "true" },
          }),
        ]),
      ]),
      _vm._v(" "),
      _vm.includeText
        ? _c("span", [
            _vm._v(
              "\n        " + _vm._s(_vm.isOpen ? "Open" : "Closed") + "\n    "
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }